import {inject, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Pack, PackModel} from '../models/pack.model';
import {Prompt, PromptModel} from '../models/prompt.model';

@Injectable({
  providedIn: 'root'
})
export class NavigateService {
  private readonly router = inject(Router)

  constructor() { }

  home() {
    this.router.navigate(['/home']).finally()
  }

  login() {
    this.router.navigate(['/login']).finally()
  }

  marketplace() {
    this.router.navigate(['/marketplace']).finally()
  }

  profile() {
    this.router.navigate(['/profile']).finally()
  }

  packs() {
    this.router.navigate(['/packs']).finally()
  }

  pack({ id }: PackModel | Pack) {
    this.router.navigate(['/packs', id]).finally()
  }

  prompts() {
    this.router.navigate(['/prompts']).finally()
  }

  prompt({id}: PromptModel | Prompt) {
    this.router.navigate(['/prompts', id]).finally()
  }
}
